import { Box, IconButton, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import BasicModal from '@/shared/ui/Modal'
import { CloseIcon } from '@/shared/ui/Icons'
import { TermsAndConditionsSection } from '@/pages/Settings/sections/TermsAndConditionsSection'

interface Props {
    isOpen: boolean
    onClose: () => void
}

const TermsAndConditionsPopUp = ({ isOpen, onClose }: Props) => {
    const { t: translate } = useTranslation()
    const theme = useTheme()

    const titleStyle = {
        typography: 'headline3',
        lineHeight: '28px',
        color: 'white',
    }

    const modalStyles = {
        width: '90vw',
        maxWidth: '900px',
        maxHeight: '90vh',
        alignItems: 'stretch',
        gap: '16px',
    }

    return (
        <BasicModal
            styles={modalStyles}
            isOpen={isOpen}
            setIsModalOpen={onClose}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                <Typography sx={titleStyle}>
                    {translate('TermsAndConditionsTitle')}
                </Typography>
                <IconButton
                    data-testid="close-terms-button"
                    onClick={onClose}
                    aria-label={translate('close') || undefined}
                    sx={{ color: theme.palette.white }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                <TermsAndConditionsSection />
            </Box>
        </BasicModal>
    )
}

export { TermsAndConditionsPopUp }
